// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"732":"9d314c10","754":"92479c22"}[chunkId] + ".chunk.css";
};